var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"finance-grid-contra"},[_c('span',[_vm._v(_vm._s(_setup.formattedAmount))]),_vm._v(" "),(_vm.agreementId)?_c('ui-icon-button',{attrs:{"size":"mini","icon":"open_in_new","color":"primary","type":"secondary"},on:{"click":_setup.showContra}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }